import { HypothesisTestsData } from '@/api/workOrders/types';
import { Box, Divider, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';
import { HypothesisSection } from '../types';

interface HypothesisProps {
  hypothesisTests: HypothesisSection;
  variableNames: string[];
}

export const Hypothesis = memo(function Hypothesis(props: HypothesisProps) {
  const { hypothesisTests, variableNames } = props;

  return (
    <Grid id="inf-hypothesis" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon
            isComplete={hypothesisTests.hypothesis_tests.every(
              (item) =>
                item.transformation.trim() !== '' &&
                Boolean(item.t_obs) &&
                Boolean(item.significance)
            )}
          />
          <Typography my={2} fontWeight={600}>
            Testes de Hipótese
          </Typography>
        </Box>
      </Grid>
      {hypothesisTests.hypothesis_tests.map(
        (item: HypothesisTestsData, index: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item xs={12} key={index}>
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <Typography variant="caption" color="text.secondary">
                  {INF_STATISTIC_FIELD_LABELS.hypothesis_variable}
                </Typography>
                <Typography>{variableNames[index] || '-'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" color="text.secondary">
                  {INF_STATISTIC_FIELD_LABELS.hypothesis_transformation}
                </Typography>
                <Typography>{item.transformation || '-'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" color="text.secondary">
                  {INF_STATISTIC_FIELD_LABELS.hypothesis_t_obs}
                </Typography>
                <Typography>{item.t_obs ?? '-'}</Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="caption" color="text.secondary">
                  {INF_STATISTIC_FIELD_LABELS.hypothesis_significance}
                </Typography>
                <Typography>{item.significance ?? '-'}</Typography>
              </Grid>
              {index !== hypothesisTests.hypothesis_tests.length - 1 && (
                <Grid item xs={12}>
                  <Divider sx={{ width: '100%' }} />
                </Grid>
              )}
            </Grid>
          </Grid>
        )
      )}
    </Grid>
  );
});
